module.exports = __webpack_public_path__ + "images/162_640.jpg";